import { FC } from 'react'
import { SOCIAL_NETWORK } from '../../../models/post'

import './AnalysticsSocialToggler.scss'

type AnalysticsSocialTogglerProps = {
  socials: SOCIAL_NETWORK[]
  activeSocial: SOCIAL_NETWORK
  setActiveSocial: (arg: any) => any
}

const AnalysticsSocialToggler: FC<AnalysticsSocialTogglerProps> = ({
  socials,
  activeSocial,
  setActiveSocial,
  children
}) => {
  return (
    <div className='analystics-social-toggler'>
      <div className='analystics-social-toggler__socials'>
        {socials.map((social: SOCIAL_NETWORK, index: number) => (
          <div
            key={`connected-social-${index}`}
            className={`analystics-social-toggler__socials__item ${
              activeSocial === social && 'active'
            }`}
            onClick={() => setActiveSocial(social)}
          >
            {social.charAt(0).toUpperCase() + social.slice(1)}
            <div className='social-backdrop'></div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AnalysticsSocialToggler
